import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import logo from "../images/Niagara3.png";

function Footer({time}) {
  return (
    <>
      <Container id="footer" fluid bg="light" variant="light" className="text-center text-muted mt-2">
      <Row>
      <Col>
                <img
                alt="logo"
                src={logo}
                height="30px"
                max-height="40px"
                className="d-block align-top img-responsive pl-2"
              />
              </Col>
        <Col><small>{time}</small></Col>
        <Col>
        <small>© Hawkeye Energy Solutions 2023</small>
        </Col>
        </Row>
      </Container>
    </>
  );
}

export default Footer;
